import React, { useEffect, useState } from "react";
import MainLayout from "../../layouts/MainLayout";
import Alert from "../../components/Alert";
import { getBkashConfigStatus, saveBkashConfig } from "../../api/bkashApi";
import "../Users/UsersPage.css";

/**
 * Platform-operator only (see `AccessService.isPlatformOperator` javadoc on
 * the backend), no real digicampusbd menu entry (bKash's one global
 * merchant credential set — `company_type = 0` — isn't a per-institute
 * delegable setting), same fixed-route pattern as InstituteProfilePage /
 * ZkDevicesPage / SchedulerConfigPage / InstituteBillPage. Never shows the
 * saved userName/password/appKey/appSecret back — only a masked status, per
 * BkashConfigStatusResponse (see MIGRATION.md Phase 9 notes).
 */
export default function BkashConfigPage() {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ userName: "", password: "", appKey: "", appSecret: "" });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const load = () => {
    setLoading(true);
    getBkashConfigStatus()
      .then(setStatus)
      .catch(() => setError("Failed to load bKash configuration status."))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const handleChange = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!window.confirm("This replaces the platform's live bKash merchant credentials. Continue?")) {
      return;
    }
    setSaving(true);
    try {
      await saveBkashConfig(form);
      setSuccess("bKash configuration saved.");
      setForm({ userName: "", password: "", appKey: "", appSecret: "" });
      load();
    } catch (err) {
      setError((err.response && err.response.data && err.response.data.message) || "Failed to save configuration.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="page-header">
        <h1>bKash Payment Configuration</h1>
      </div>
      <Alert type="error" onDismiss={() => setError("")}>
        {error}
      </Alert>
      <Alert type="success" onDismiss={() => setSuccess("")}>
        {success}
      </Alert>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <div style={{ marginBottom: 24 }}>
          <h3>Current Status</h3>
          {status && status.configured ? (
            <ul>
              <li>Configured: Yes</li>
              <li>Merchant Number: {status.userName}</li>
              <li>Token Expires At: {status.tokenExpiresAt || "Not issued yet"}</li>
            </ul>
          ) : (
            <p>Not configured yet — bKash payments are disabled until credentials are saved below.</p>
          )}
        </div>
      )}

      <h3>{status && status.configured ? "Replace Credentials" : "Configure Credentials"}</h3>
      <form onSubmit={handleSubmit} className="user-form">
        <label>Merchant Username</label>
        <input value={form.userName} onChange={handleChange("userName")} required />
        <label>Merchant Password</label>
        <input type="password" value={form.password} onChange={handleChange("password")} required />
        <label>App Key</label>
        <input value={form.appKey} onChange={handleChange("appKey")} required />
        <label>App Secret</label>
        <input type="password" value={form.appSecret} onChange={handleChange("appSecret")} required />
        <div className="form-actions">
          <button type="submit" className="btn-primary" disabled={saving}>
            {saving ? "Saving..." : "Save Configuration"}
          </button>
        </div>
      </form>
    </MainLayout>
  );
}
